import { useMemo } from 'react'
import { useWatch } from 'react-hook-form'
import { TextField } from '@ui/forms'
import { formatPageSelection, getExcludedPages, getMissingPages, parsePageSelection } from './utils'

interface Props {
  /** Page count of the file as laid out in the viewer, if loaded */
  pageCount?: number
}

const PageSelectionField = ({ pageCount }: Props) => {
  const pageSelection: string = useWatch({ name: 'page_selection' })

  const helperText = useMemo(() => {
    const pages = parsePageSelection(pageSelection ?? '')

    const pageCountText = pageCount
      ? `Das Dokument hat ${pageCount} ${pageCount === 1 ? 'Seite' : 'Seiten'}.`
      : undefined
    // Only reachable for a saved selection; new ones are rejected by the form validation
    const missingPages = getMissingPages(pageCount, pages)
    const missingText = missingPages.length
      ? `Seite ${missingPages.join(', ')} existiert nicht mehr, bitte Auswahl anpassen.`
      : undefined
    const excludedPages = pageCount ? getExcludedPages(pageCount, pages) : []
    const excludedText = excludedPages.length
      ? `Nicht eingefügt: ${excludedPages.length === 1 ? 'Seite' : 'Seiten'} ${formatPageSelection(
          excludedPages,
        )}.`
      : undefined

    return ['Leer lassen, um alle Seiten einzufügen.', pageCountText, missingText, excludedText]
      .filter(Boolean)
      .join(' ')
  }, [pageSelection, pageCount])

  return (
    <TextField
      name="page_selection"
      label="Seitenbereich"
      placeholder="z. B. 1-3, 5"
      helperText={helperText}
      data-cy="document-page-selection"
    />
  )
}

export default PageSelectionField
